import {useNavigate} from "react-router-dom";
import {useState} from "react";
import {handleError} from "../utils2";

export function usePostJson(url, jwtToken = null, cb = null, defaultValue = null) {
    const navigate = useNavigate()
    const [value, setValue] = useState(defaultValue)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    function sendData(payload, form = null) {
        if (url == null) {
            return setError("URL unprovided")
        }

        const bearer = jwtToken ? {Authorization: `Bearer ${jwtToken}`} : null

        const requestOptions = {
            method: "POST",
            headers: {"Accept": "application/json", "Content-Type": "application/json", ...bearer},
            body: JSON.stringify(payload)
        }

        setLoading(true)
        fetch(url, requestOptions)
            .then(resp => resp?.ok ? resp.text() : Promise.reject({error: `Response status: ${resp.status}`}))
            .then(text => JSON.parse(text))
            .then(json => {
                if (json?.ok || json?.success) {
                    setValue(json.body) //TODO check for json.data
                    if (typeof form === "function") {
                        form(json)
                    } else if (typeof form === "string") {
                        navigate(form)
                    }
                    if (typeof cb === "function") {
                        cb(json, form)
                    } else if (typeof cb === "string") {
                        navigate(cb)
                    }
                    console.debug("Got: ", json?.body)
                } else {
                    console.warn("Got: ", JSON.stringify(json))
                    return Promise.reject(json)
                }
            })
            .catch(handleError)
            .catch(err => {
                console.warn(err)
                return Promise.reject(err)
            })
            .catch(setError)
            .finally(() => setLoading(false))
    }

    const clearError = () => setError(null)

    return [sendData, value, loading, error, clearError, setValue, setLoading]
}

export function usePostGeneric(url, jwtToken = null, cb = null, defaultValue = null) {
    const navigate = useNavigate()
    const [value, setValue] = useState(defaultValue)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    function sendData(payload, form = null) {
        if (url == null) {
            return setError("URL unprovided")
        }

        const formData = new FormData()
        console.log("Payload.upload_audio:", payload.upload_audio)
        // if (Object.hasOwn(payload, "upload_audio"))
        //     formData.append("upload_audio", payload.upload_audio)

        Object.keys(payload).forEach(key => {
            formData.append(key, payload[key]);
        });

        const requestOptions = {
            method: "POST",
            headers: {...{Authorization: `Bearer ${jwtToken}`}},
            body: formData
        }

        setLoading(true)
        fetch(url, requestOptions)
            .then(resp => resp?.ok ? resp.text() : Promise.reject({error: `Response status: ${resp.status}`}))
            .then(text => JSON.parse(text))
            .then(json => {
                if (json?.ok || json?.success) {
                    setValue(json.body)
                    if (typeof form === "function") {
                        form(json)
                    } else if (typeof form === "string") {
                        navigate(form)
                    }
                    if (typeof cb === "function") {
                        cb(json, form)
                    } else if (typeof cb === "string") {
                        navigate(cb)
                    }
                    console.debug("Got: ", json?.body)
                } else {
                    console.warn("Got: ", JSON.stringify(json))
                    return Promise.reject(json)
                }
            })
            .catch(handleError)
            .catch(err => {
                console.warn(err)
                return Promise.reject(err)
            })
            .catch(setError)
            .finally(() => setLoading(false))
    }

    const clearError = () => setError(null)

    return [sendData, value, loading, error, clearError, setValue, setLoading]
}